export default {
    data() {
        return {
            isExporting: false
        };
    },
    methods: {
        onSuccessExport(message) {
            this._message(message, "info");
        },
        onErrorExport(message) {
            this._message(message, "warning");
        },
        async exportPdf({ httpMethod, parameters, paramsId }) {
            try {
                let response = await this.$http({
                    method: httpMethod,
                    url: `${process.env.BARRACUDA}report/pdf-request/${paramsId}`,
                    data: httpMethod === "POST" ? parameters : {},
                    params: httpMethod === "GET" ? parameters : {}
                });

                if (response.status === 200) {
                    if (response.data.queue) {
                        this.onSuccessExport(response.data.message);
                    } else if (response.data.response !== undefined) {
                        let data = response.data.response.resource;
                        if (data.path) {
                            this._redirect(
                                data.path + "?" + moment().unix(),
                                true,
                                500
                            );
                        }
                    } else {
                        this.onErrorExport("No records available");
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.resetLoading();
            }
        },
        async exportCsv({ httpMethod, parameters, paramsId }) {
            try {
                let response = await this.$http({
                    method: httpMethod,
                    url: `${process.env.BARRACUDA}report/csv-request/${paramsId}`,
                    data: httpMethod === "POST" ? parameters : {},
                    params: httpMethod === "GET" ? parameters : {}
                });

                if (response.status === 200) {
                    if (response.data.queue) {
                        this.onSuccessExport(response.data.message);
                    } else if (response.data.response !== undefined) {
                        let data = response.data.response.resource;
                        if (data.ObjectURL) {
                            this._redirect(data.ObjectURL, true, 500);
                        }
                    } else {
                        this.onErrorExport("No records available");
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.resetLoading();
            }
        },
        async exportCsvQueue({ parameters, paramsId }) {
            try {
                let response = await this.$http.post(
                    `${process.env.BARRACUDA}report/gen-csv-report-queue/${paramsId}`,
                    parameters
                );

                if (response.data.mode == 0) {
                    this.onSuccessExport(response.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.resetLoading();
            }
        },
        async exportPdfToQueue({ parameters, paramsId }) {
            try {
                let response = await this.$http.post(
                    `${process.env.BARRACUDA}report/gen-pdf-report-queue/${paramsId}`,
                    parameters
                );

                if (response.data.mode == 0) {
                    this.onSuccessExport(response.data.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.resetLoading();
            }
        },
        async exportReport({ option, parameters }) {
            this.isExporting = true;

            let httpMethod = "GET";
            let paramsId =
                this.$route.name == "custom_report"
                    ? this.$route.params.id
                    : parseInt(this.$route.params.id);

            switch (option) {
                case 1:
                    return await this.exportPdf({
                        httpMethod,
                        parameters,
                        paramsId
                    });

                //-- Push generate csv report to queue and trigger task
                case 2:
                    return await this.exportCsvQueue({ parameters, paramsId });

                //-- Push generate pdf report to queue and trigger task
                case 3:
                    return await this.exportPdfToQueue(parameters, paramsId);

                default:
                    await this.exportCsv({ httpMethod, parameters, paramsId });
            }
        },
        resetLoading() {
            this.isExporting = false;
        }
    }
};
